require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-record-your-favorite-drinks-with-cocktail-manager.json") })
        }
      }, "path---blog-record-your-favorite-drinks-with-cocktail-manager");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-record-your-favorite-drinks-with-cocktail-manager!./.cache/json/blog-record-your-favorite-drinks-with-cocktail-manager.json
// module id = 1051
// module chunks = 231608221292675